module.exports = __webpack_public_path__ + "static/media/image-15.7349113e.jpg";